import { useMemo } from 'react';
import { hasMultipleBillingTerms } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import { mapProductsByTierToCards } from './hsocPublicCards';
/*
 * Maps shared tier options (owned by the page via useHsocPublicTierOptions, so
 * the tier query, its loading, and its error live in one place) into the merch
 * card props. selectedTerm is controlled by the page so the cards and the
 * feature-table plan-details stay in sync with the billing-term toggle.
 * Mirrors the in-app useHsocInAppPricing.
 */
export function useHsocPublicPricing(tierOptions, currencyCode, selectedTerm) {
  const {
    productsByTier,
    products
  } = tierOptions;

  /* TODO(#22236): badge is still a placeholder; the V2 tier data does not yet
   * expose a badge field to map from. */
  const cards = useMemo(() => mapProductsByTierToCards(productsByTier, products !== null && products !== void 0 ? products : {}, currencyCode, selectedTerm), [productsByTier, products, currencyCode, selectedTerm]);
  const showTermToggle = useMemo(() => hasMultipleBillingTerms(productsByTier), [productsByTier]);
  return {
    cards,
    showTermToggle
  };
}